import React, { useState, useEffect } from "react";
import RequestService from "../../services/RequestService";
import { useOutletContext } from 'react-router-dom';
import { FaCircle } from "react-icons/fa";
import { parseISO, format, addDays, differenceInCalendarDays } from "date-fns";
import RequestDetailsModal from "../modals/RequestDetailsModal";
import { FaFileExcel } from "react-icons/fa";
import { FaLongArrowAltDown } from "react-icons/fa";
import exportToExcelConsultaGerAtendimentos from '../../utils/exportToExcelConsultaGerAtendimentos';
// import { isSLAPassed, isSLANear } from "../../utils/SLACalcs";
import CompanyService from "../../services/CompanyService"
import TiposAtendimento from "../../enums/TiposAtendimento";
import GmoService from '../../services/GmoService';
import StatusRequests from '../../enums/StatusRequests'
import TiposBoleto from "../../enums/TiposBoleto";
import DepositService from './../../services/DepositService';
import Estados from "../../enums/Estados";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { toast } from "react-toastify";


export default function ConsultaGerencialAtendimento() {

  const [requestList, setRequestList] = useState({ requests: [], totalPages: 1 });
  const [currentPageRequests, setCurrentPageRequests] = useState(null);
  const [requestDetailsModal, setRequestDetailsModal] = useState(false);
  const [requestOnDetailsModal, setRequestOnDetailsModal] = useState();
  const [companiesList, setCompaniesList] = useState([])
  const [gmoList, setGmoList] = useState([]);
  const [depositList, setDepositList] = useState([]);
  const [shouldFetchRequests, setShouldFetchRequests] = useState(false);

  const { user } = useOutletContext();

  const MAX_RANGE_DAYS = 90;
  const whiteListEmails = ['junior.silva@amerinode.com.br', 'guilherme.alberto@amerinode.com.br', 'jean.medeiros@amerinode.com.br', 'thiago.bellon@amerinode.com.br', 'raiane.oliveira@amerinode.com.br'];


  //filters
  const [search, setSearch] = useState('');
  const [searchUF, setSearchUF] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  const [searchIdRequest, setSearchIdRequest] = useState('');
  const [searchTecnico, setSearchTecnico] = useState('');
  const [searchReTecnico, setSearchReTecnico] = useState('');
  const [searchEmpresa, setSearchEmpresa] = useState('');
  const [searchCodSap, setSearchCodSap] = useState('');
  const [searchTipoAtendimento, setSearchTipoAtendimento] = useState('');
  const [searchIdBoleto, setSearchIdBoleto] = useState('');
  const [searchTipoBoleto, setSearchTipoBoleto] = useState('');
  const [searchSite, setSearchSite] = useState('');
  const [searchGmo, setSearchGmo] = useState('');
  const [searchDrsOrigem, setSearchDrsOrigem] = useState('');
  const [searchDrsAtender, setSearchDrsAtender] = useState('');
  const [searchQtdSolicitadaPrefix, setSearchQtdSolicitadaPrefix] = useState('');
  const [searchQtdSolicitada, setSearchQtdSolicitada] = useState('');
  const [searchSerial, setSearchSerial] = useState('');
  const [searchIsLocker, setSearchIsLocker] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [startDateEntrega, setStartDateEntrega] = useState('');
  const [endDateEntrega, setEndDateEntrega] = useState('');
  // const [status, setStatus] = useState('');

  // useEffect(() => {
    
  //   // async function fetchRequests() {
  //   //   const status = '?status=GESTAO'
  //   //   const requestsNovas = await RequestService.getRequest(status);
  //   //   setRequestList(requestsNovas);
  //   // }

  //   // fetchRequests();


  //   // Função para buscar os requests
  //   const fetchRequests = async () => {

  //     const params = new URLSearchParams();
  //     if (search) params.append('search', search);
  //     if (startDate) params.append('startDate', startDate);
  //     if (endDate) params.append('endDate', endDate);
  //     // if (status) params.append('status', status);
    
  //     const queryString = params.toString();
  //     const requestsNovas = await RequestService.getRequest(`?${queryString}`);
      
  //     setRequestList(requestsNovas);
  //   };

  //   // Chamada inicial
  //   fetchRequests();

  //   // Configuração do intervalo para as chamadas subsequentes (a cada 10 segundos)
  //   const intervalId = setInterval(fetchRequests, 10000);

  //   // Limpa o intervalo quando o componente for desmontado
  //   return () => clearInterval(intervalId);
  // }, [endDate, search, startDate]);

  useEffect(()=>{

    const fetchData = async () =>{
      const result = await CompanyService.getCompanies();
      const gmos = await GmoService.getGmos();
      const deposits = await DepositService.getDeposits();

      setCompaniesList(result.companies)
      setGmoList(gmos.gmos)
      setDepositList(deposits.deposits);
    }
    fetchData();   

  }, []);

  const fetchRequests = async (page = 1) => {
    if(page === 1){
      setCurrentPageRequests(1); // Reseta a página atual para 1 quando uma nova busca é feita
    }
    const params = new URLSearchParams();
    if (searchUF) params.append('uf', searchUF);
    if (searchStatus) params.append('status', searchStatus);
    if (searchIdRequest) params.append('idrequest', searchIdRequest);
    if (searchTecnico) params.append('tecnico', searchTecnico);
    if (searchReTecnico) params.append('retecnico', searchReTecnico);
    if (searchEmpresa) params.append('company', searchEmpresa);
    if (searchCodSap) params.append('codsap', searchCodSap);
    if (searchTipoAtendimento) params.append('tipoatendimento', searchTipoAtendimento);
    if (searchIdBoleto) params.append('idboleto', searchIdBoleto);
    if (searchTipoBoleto) params.append('tipoboleto', searchTipoBoleto);
    if (searchSite) params.append('site', searchSite);
    if (searchGmo) params.append('gmo', searchGmo);
    if (searchDrsOrigem) params.append('drsorigem', searchDrsOrigem);
    if (searchDrsAtender) params.append('drsatender', searchDrsAtender);
    if (searchQtdSolicitadaPrefix) params.append('qtdsolprefix', searchQtdSolicitadaPrefix);
    if (searchQtdSolicitada) params.append('qtdsol', searchQtdSolicitada);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (startDateEntrega) params.append('startDateEntrega', startDateEntrega);
    if (endDateEntrega) params.append('endDateEntrega', endDateEntrega);
    if (searchSerial) params.append('serial', searchSerial);
    if (searchIsLocker) params.append('is_locker', 'true');

    const queryString = params.toString();
    const itemsPerPage = 15;

    try {
      const requestsNovas = await RequestService.getRequest(`?${queryString}`, page, itemsPerPage);
      if (requestsNovas) {
        setRequestList(requestsNovas);
        // setCurrentPageRequests(page);
        toast.success("Relatório gerado!");
      } else {
        toast.error("Ops! Não foi possível gerar o relatório!");
      }
    } catch (error) {
      toast.error(error?.message || "Ops! Não foi possível gerar o relatório!");
    }
    
  };

  const clampEndToMaxRange = (startStr, endStr) => {
    try {
      const start = parseISO(startStr);
      const end = parseISO(endStr);
      const diff = differenceInCalendarDays(end, start);
      if (diff > MAX_RANGE_DAYS) {
        const capped = addDays(start, MAX_RANGE_DAYS);
        return format(capped, "yyyy-MM-dd"); // value for <input type="date">
      }
      return endStr;
    } catch (e) {
      return endStr;
    }
  };

  const handleSearch = () => {
    // valida intervalo "Aberto de / até"
    if (startDate && endDate) {
      try {
        const diff = differenceInCalendarDays(parseISO(endDate), parseISO(startDate));
        if (diff > MAX_RANGE_DAYS && !whiteListEmails.includes(user.email)) {
          toast.error(`Intervalo 'Aberto' não pode ser maior que ${MAX_RANGE_DAYS} dias.`);
          return;
        }
      } catch (e) {
        toast.error("Datas inválidas no filtro 'Aberto'.");
        return;
      }
    }

    // valida intervalo "Entregue de / até"
    if (startDateEntrega && endDateEntrega) {
      try {
        const diffEntrega = differenceInCalendarDays(parseISO(endDateEntrega), parseISO(startDateEntrega));
        if (diffEntrega > MAX_RANGE_DAYS && !whiteListEmails.includes(user.email)) {
          toast.error(`Intervalo 'Entregue' não pode ser maior que ${MAX_RANGE_DAYS} dias.`);
          return;
        }
      } catch (e) {
        toast.error("Datas inválidas no filtro 'Entregue'.");
        return;
      }
    }

    // tudo ok -> chama a busca
    fetchRequests(1); // Chama a busca na página 1
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= requestList.totalPages) {
      fetchRequests(newPage); // Chama a busca na página selecionada
    }
    setCurrentPageRequests(newPage); // Atualiza o estado da página atual
  };

  // useEffect(() => {
  //   if (currentPageRequests !== null) {
  //     fetchRequests(currentPageRequests); // Só chama fetchRequests se currentPageRequests não for null
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentPageRequests]);
  

  const handleRequestDetailsModal = async (ticketId) => {
    setRequestDetailsModal(true)
    setRequestOnDetailsModal(ticketId)
  };

  const clearFilters = () => {
    setSearch('');
    setSearchUF('');
    setSearchStatus('');
    setStartDate('');
    setEndDate('');
    setStartDateEntrega('');
    setEndDateEntrega('');
    setSearchIdRequest('');
    setSearchTecnico('');
    setSearchReTecnico('');
    setSearchEmpresa('');
    setSearchCodSap('')
    setSearchTipoAtendimento('')
    setSearchIdBoleto('')
    setSearchTipoBoleto('')
    setSearchSite('')
    setSearchGmo('')
    setSearchDrsOrigem('')
    setSearchDrsAtender('')
    setSearchQtdSolicitadaPrefix('')
    setSearchQtdSolicitada('')
    setSearchSerial('')
    setSearchIsLocker(false)
    setRequestList({ requests: [], totalPages: 1 });
    // setStatus('');
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    console.log(e.target.value)
  };

  const handleStartDateChange = (e) => {
    const val = e.target.value;
    setStartDate(val);

    if (endDate) {
      try {
        const diff = differenceInCalendarDays(parseISO(endDate), parseISO(val));
        if (diff > MAX_RANGE_DAYS && !whiteListEmails.includes(user.email)) {
          toast.warn(`Intervalo 'Aberto' maior que ${MAX_RANGE_DAYS} dias. Ao clicar em Buscar a consulta será bloqueada.`);
        }
      } catch (err) {
        // ignore parse errors here
      }
    }
    console.log(val);
  };

  const handleEndDateChange = (e) => {
    const val = e.target.value;
    setEndDate(val);

    if (startDate) {
      try {
        const diff = differenceInCalendarDays(parseISO(val), parseISO(startDate));
        if (diff > MAX_RANGE_DAYS && !whiteListEmails.includes(user.email)) {
          toast.warn(`Intervalo 'Aberto' maior que ${MAX_RANGE_DAYS} dias. Ao clicar em Buscar a consulta será bloqueada.`);
        }
      } catch (err) {
        // ignore parse errors here
      }
    }
    console.log(val);
  };

  const handleStartDateEntregaChange = (e) => {
    const val = e.target.value;
    setStartDateEntrega(val);

    if (endDateEntrega) {
      try {
        const diff = differenceInCalendarDays(parseISO(endDateEntrega), parseISO(val));
        if (diff > MAX_RANGE_DAYS && !whiteListEmails.includes(user.email)) {
          toast.warn(`Intervalo 'Entregue' maior que ${MAX_RANGE_DAYS} dias. Ao clicar em Buscar a consulta será bloqueada.`);
        }
      } catch (err) {
        // ignore parse errors here
      }
    }
    console.log(val);
  };

  const handleEndDateEntregaChange = (e) => {
    const val = e.target.value;
    setEndDateEntrega(val);

    if (startDateEntrega) {
      try {
        const diff = differenceInCalendarDays(parseISO(val), parseISO(startDateEntrega));
        if (diff > MAX_RANGE_DAYS && !whiteListEmails.includes(user.email)) {
          toast.warn(`Intervalo 'Entregue' maior que ${MAX_RANGE_DAYS} dias. Ao clicar em Buscar a consulta será bloqueada.`);
        }
      } catch (err) {
        // ignore parse errors here
      }
    }
    console.log(val);
  };

  // const handleStatusChange = (e) => {
  //   setStatus(e.target.value);
  //   console.log(e.target.value)
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // Implement your search logic here
  //   console.log('Search:', search);
  //   console.log('Start Date:', startDate);
  //   console.log('End Date:', endDate);
  //   // console.log('Status:', status);
  // };

  const handleExportToExcel = async () => {

    const params = new URLSearchParams();
    if (searchUF) params.append('uf', searchUF);
    if (searchStatus) params.append('status', searchStatus);
    if (searchIdRequest) params.append('idrequest', searchIdRequest);
    if (searchTecnico) params.append('tecnico', searchTecnico);
    if (searchReTecnico) params.append('retecnico', searchReTecnico);
    if (searchEmpresa) params.append('company', searchEmpresa);
    if (searchCodSap) params.append('codsap', searchCodSap);
    if (searchTipoAtendimento) params.append('tipoatendimento', searchTipoAtendimento);
    if (searchIdBoleto) params.append('idboleto', searchIdBoleto);
    if (searchTipoBoleto) params.append('tipoboleto', searchTipoBoleto);
    if (searchSite) params.append('site', searchSite);
    if (searchGmo) params.append('gmo', searchGmo);
    if (searchDrsOrigem) params.append('drsorigem', searchDrsOrigem);
    if (searchDrsAtender) params.append('drsatender', searchDrsAtender);
    if (searchQtdSolicitadaPrefix) params.append('qtdsolprefix', searchQtdSolicitadaPrefix);
    if (searchQtdSolicitada) params.append('qtdsol', searchQtdSolicitada);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (startDateEntrega) params.append('startDateEntrega', startDateEntrega);
    if (endDateEntrega) params.append('endDateEntrega', endDateEntrega);
    if (searchIsLocker) params.append('is_locker', 'true');

    const queryString = params.toString();
    const requestsExcel = await RequestService.getRequest(`?${queryString}`, currentPageRequests, 0, true);
  
    // setRequestListExcel(requestsExcel);
    exportToExcelConsultaGerAtendimentos(requestsExcel.requests)
  }


  return (
    <div className="flex w-full h-full justify-center items-center py-4 px-4 bg-gray-200">

      <div className="flex flex-col w-full h-full rounded-xl py-8 px-6 gap-12 bg-white">

      <div className="flex flex-col w-full h-full gap-4 border border-gray-800 border-opacity-40 rounded-xl p-2">

          <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-2">
            <div className="flex items-center gap-1 w-full">
              <HiOutlineDocumentReport size={20} />
              <p>Consulta Gerencial de Atendimentos</p>
            </div>

            <button onClick={() => handleExportToExcel(requestList.requests)} className="flex justify-center items-center bg-green-600 px-2 py-1 rounded-lg text-white gap-2">
              <FaFileExcel />
              <div>Exportar</div>
            </button>
          </div>

          <div className="flex flex-col justify-between w-full h-full">

            <div className="flex flex-col gap-4 max-h-full">

              {/* FILTROS */}
              <div className="flex flex-wrap gap-2 items-end text-[10px]">
                {/* <div className="flex flex-col">
                  <label className="text-[10px] font-semibold ms-2">Pesquisar</label>
                  <input
                    type="text"
                    placeholder="Search"
                    // value={search}
                    onBlur={handleSearchChange}
                    className="block w-full rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div> */}
                <div className="flex flex-col w-fit">
                  <label className="text-[10px] font-semibold ms-2">UF</label>
                  <select
                    defaultValue=""
                    value={searchUF}
                    onChange={(e) => setSearchUF(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled></option>
                    {Estados.map((uf, index) => (
                      <option key={index} value={uf.sigla}>{uf.sigla}</option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">Nº Solicitação</label>
                  <input
                    type="text"
                    placeholder="ID Requisição"
                    value={searchIdRequest}
                    onChange={(e) => setSearchIdRequest(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                {/* <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">Nome Técnico</label>
                  <input
                    type="text"
                    placeholder="Nome Técnico"
                    value={searchTecnico}
                    onChange={(e) => setSearchTecnico(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div> */}
                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">RE Técnico</label>
                  <input
                    type="text"
                    placeholder="RE Técnico"
                    value={searchReTecnico}
                    onChange={(e) => setSearchReTecnico(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">Status</label>
                  <select
                    defaultValue=""
                    value={searchStatus}
                    onChange={(e) => setSearchStatus(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled>Selecione</option>
                    {Object.keys(StatusRequests).map((key, index) => (
                      <option key={index} value={key}>{StatusRequests[key].descricao}</option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">Cód Sap</label>
                  <input
                    type="text"
                    placeholder="Cód Sap"
                    value={searchCodSap}
                    onChange={(e) => setSearchCodSap(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col w-40">
                  <label className="text-[10px] font-semibold ms-2">Empresa</label>
                  <select
                    defaultValue=""
                    value={searchEmpresa}
                    onChange={(e) => setSearchEmpresa(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled>Selecione</option>
                    {companiesList.map((company) => (
                      <option key={company._id} value={company._id}>
                        {company.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col w-fit">
                  <label className="text-[10px] font-semibold ms-2">Tipo Atendimento</label>
                  <select
                    defaultValue=""
                    value={searchTipoAtendimento}
                    onChange={(e) => setSearchTipoAtendimento(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled>Selecione</option>
                    {TiposAtendimento.map((tipo, index) => (
                      <option key={index} value={tipo.cod}>{tipo.descricao}</option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">ID Boleto</label>
                  <input
                    type="text"
                    placeholder="ID Boleto"
                    value={searchIdBoleto}
                    onChange={(e) => setSearchIdBoleto(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col w-40">
                  <label className="text-[10px] font-semibold ms-2">Tipo Boleto</label>
                  <select
                    defaultValue=""
                    value={searchTipoBoleto}
                    onChange={(e) => setSearchTipoBoleto(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled>Selecione</option>
                    {TiposBoleto.map((tipo, index) => (
                      <option key={index} value={tipo.cod}>{tipo.descricao}</option>
                    ))}
                  </select>
                </div>

                <div className="flex gap-2 rounded-lg bg-zinc-200 px-2">
                  <div className="flex flex-col min-w-32">
                    <label className="text-[10px] font-semibold ms-2">Aberto de</label>
                    <input
                      type="date"
                      placeholder="Start Date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  <div className="flex flex-col min-w-32">
                    <label className="text-[10px] font-semibold ms-2">até</label>
                    <input
                      type="date"
                      placeholder="End Date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                </div>

                <div className="flex gap-2 rounded-lg bg-zinc-200 px-2">
                  <div className="flex flex-col min-w-32">
                    <label className="text-[10px] font-semibold ms-2">Entregue de</label>
                    <input
                      type="date"
                      placeholder="Start Date"
                      value={startDateEntrega}
                      onChange={handleStartDateEntregaChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  <div className="flex flex-col min-w-32">
                    <label className="text-[10px] font-semibold ms-2">até</label>
                    <input
                      type="date"
                      placeholder="End Date"
                      value={endDateEntrega}
                      onChange={handleEndDateEntregaChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                </div>

                <div className="flex gap-2 rounded-lg bg-zinc-200 px-2">
                  <div className="flex flex-col min-w-fit">
                    <label className="text-[10px] font-semibold ms-2">Qtd Solicitada</label>
                    <select
                      defaultValue=""
                      value={searchQtdSolicitadaPrefix}
                      onChange={(e) => setSearchQtdSolicitadaPrefix(e.target.value)}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    >
                      <option value="" disabled>Selecione</option>
                      <option value="menorque">Menor igual a</option>
                      <option value="igual">Igual a</option>
                      <option value="maiorque">Maior igual a</option>
                    </select>
                  </div>
                  <div className="flex flex-col w-16">
                    <label className="text-[10px] font-semibold ms-2">Qtd</label>
                    <input
                      type="text"
                      placeholder="valor"
                      value={searchQtdSolicitada}
                      onChange={(e) => setSearchQtdSolicitada(e.target.value)}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>

                </div>

                <div className="flex flex-col w-24">
                  <label className="text-[10px] font-semibold ms-2">Site</label>
                  <input
                    type="text"
                    placeholder="Site"
                    value={searchSite}
                    onChange={(e) => setSearchSite(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col w-40">
                  <label className="text-[10px] font-semibold ms-2">Gmo</label>
                  <select
                    defaultValue=""
                    value={searchGmo}
                    onChange={(e) => setSearchGmo(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled>Selecione</option>
                    {gmoList.map((gmo) => (
                      <option key={gmo._id} value={gmo._id}>
                        {gmo.cidade} - {gmo.endereco}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col w-40">
                  <label className="text-[10px] font-semibold ms-2">DRS Origem</label>
                  <select
                    defaultValue=""
                    value={searchDrsOrigem}
                    onChange={(e) => setSearchDrsOrigem(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled>Selecione</option>
                    {depositList.map((deposit) => (
                      <option key={deposit._id} value={deposit._id}>
                        {deposit.cidade} - {deposit.sigla}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex flex-col w-40">
                  <label className="text-[10px] font-semibold ms-2">DRS Atender</label>
                  <select
                    defaultValue=""
                    value={searchDrsAtender}
                    onChange={(e) => setSearchDrsAtender(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled>Selecione</option>
                    {depositList.map((deposit) => (
                      <option key={deposit._id} value={deposit._id}>
                        {deposit.cidade} - {deposit.sigla}
                      </option>
                    ))}
                  </select>
                </div>

                {/* <div className="flex flex-col">
                  <label className="text-sm font-semibold">Status</label>
                  <select
                    value={status}
                    onChange={handleStatusChange}
                    className="border border-gray-300 rounded px-2 py-2"
                  >
                    <option value="">Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div> */}

                <div className="flex flex-col w-32">
                  <label className="text-[10px] font-semibold ms-2">Cód Barras</label>
                  <input
                    type="text"
                    placeholder="Serial"
                    value={searchSerial}
                    onChange={(e) => setSearchSerial(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>

                <div className="flex flex-col items-start">
                  <label className="text-[10px] font-semibold ms-2">Locker</label>
                  <label className="flex items-center gap-2 h-5 text-[11px] text-gray-700 cursor-pointer select-none ms-2">
                    <input
                      type="checkbox"
                      checked={searchIsLocker}
                      onChange={(e) => setSearchIsLocker(e.target.checked)}
                      className="cursor-pointer"
                    />
                    Apenas Locker
                  </label>
                </div>

                <div className="flex gap-2 items-end">
                  {/* <button onClick={handleSubmit} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                  Buscar
                </button> */}
                  <button onClick={clearFilters} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                    Limpar Filtros
                  </button>
                  <button onClick={handleSearch} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                    Buscar
                  </button>
                </div>

              </div>

              {/* TABELA */}
              <div className="w-full mt-4">
                <div className="flex gap-1 ms-2 text-xs">Total: <div className="font-bold">{requestList.totalRequests} registros</div></div>
                <div className="overflow-x-auto">
                  <table className="min-w-full bg-white rounded-lg text-[10px]">
                    <thead className="bg-gray-200">
                      <tr>
                        <th className="py-2 px-4 border-b rounded-tl-lg">UF</th>
                        <th className="py-2 px-4 border-b">Status</th>
                        <th className="py-2 px-4 border-b">Nº Solicitação</th>
                        <th className="py-2 px-4 border-b">Técnico</th>
                        <th className="py-2 px-4 border-b">Empresa</th>
                        <th className="py-2 px-4 border-b">Criado em</th>
                        <th className="py-2 px-4 border-b">Cod Sap</th>
                        <th className="py-2 px-4 border-b">Qtd Solicitada</th>
                        <th className="py-2 px-4 border-b">Qtd Cortada</th>
                        <th className="py-2 px-4 border-b">Qtd Atender</th>
                        <th className="py-2 px-4 border-b">Qtd Atendida</th>
                        <th className="py-2 px-4 border-b">Corte Total</th>
                        <th className="py-2 px-4 border-b">Qtd Pendente</th>
                        <th className="py-2 px-4 border-b">Site</th>
                        <th className="py-2 px-4 border-b">DRS Original</th>
                        <th className="py-2 px-4 border-b">DRS a Atender</th>
                        <th className="py-2 px-4 border-b">GMO</th>
                        <th className="py-2 px-4 border-b">ID Boleto</th>
                        <th className="py-2 px-4 border-b">Tipo Boleto</th>
                        <th className="py-2 px-4 border-b">Atendimento</th>
                        <th className="py-2 px-4 border-b">Telefone</th>
                        <th className="py-2 px-4 border-b"><div className="flex justify-center items-center">Data SLA<FaLongArrowAltDown /></div></th>
                        <th className="py-2 px-4 border-b rounded-tr-lg">Recebido</th>
                        {/* <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {requestList.requests?.map((request, index) => (
                        <tr key={index} className={`border-b hover:bg-gray-100s`}>
                          <td className="py-1 px-4">{request.uf}</td>
                          <td className="py-1 px-4">
                            <div className="flex justify-start items-center gap-2 min-w-28">
                              <FaCircle
                                className="flex-none"
                                color={StatusRequests[request.status]?.cor || "#000000"}
                                size={15}
                              />
                              {request.status}
                            </div>
                          </td>
                          <td className="py-1 px-4 cursor-pointer underline font-bold whitespace-nowrap" onClick={() => handleRequestDetailsModal(request._id)}>{request.idRequest}</td>
                          <td className="py-1 px-4">{request.tecnico || request.nomeSolicitante}</td>
                          <td className="py-1 px-4">{request.empresaTecnico?.socialName || request.empresaSolicitante}</td>
                          <td className="py-1 px-4">{format(parseISO(request.createdAt), 'dd/MM/yy HH:mm')}</td>
                          <td className="py-1 px-4 whitespace-nowrap">{request.codSap}</td>
                          <td className="py-1 px-4 bg-gray-200"><div className="flex justify-center items-center gap-2">{request.quantidadeSolicitada}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeCortada}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeAtender}</div></td>
                          <td className="py-1 px-4 bg-gray-200"><div className="flex justify-center items-center gap-2">{request.quantidadeAtendida}</div></td>
                          <td className="py-1 px-4 bg-gray-200"><div className="flex justify-center items-center gap-2">{request.quantidadeCortadaTotal}</div></td>
                          <td className="py-1 px-4 bg-gray-200"><div className="flex justify-center items-center gap-2">{request.quantidadePendente}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.site}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.drsOriginal?.sigla}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.drsAtender?.sigla}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.gmo.cidade}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.idBoleto}</div></td>
                          <td className="py-1 px-4"><div className="flex justify-start items-center gap-2 min-w-24">{request.tipoBoleto}</div></td>
                          <td className="py-1 px-4">
                            <div className="flex justify-center items-center gap-2">
                              {["bbn-alta", "bbn-media"].includes(request.tipoAtendimento) ? (
                                <span className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                                  {request.tipoAtendimento.toUpperCase()}
                                </span>
                              ) : (
                                request.tipoAtendimento.toUpperCase()
                              )}
                            </div>
                          </td>
                          <td className="py-1 px-4 whitespace-nowrap">{request.user.phone}</td>
                          <td className="py-1 px-4">
                            {request?.slaDate ? format(parseISO(request.slaDate), 'dd/MM/yy HH:mm') : ""}
                          </td>
                          <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.dataHoraRecebimento ? format(parseISO(request.dataHoraRecebimento), 'dd/MM/yy HH:mm') : ''}</div></td>
                          {/* <td className="py-1 px-4">
                        <div className="flex justify-center gap-2">
                          <button
                            className=" bg-sky-700 rounded-full px-2 py-1 text-white text-sm"
                            onClick={()=>{}}
                          >
                            Atender
                          </button>
                          <button 
                            className=" bg-gray-700 rounded-full px-2 py-1 text-white text-sm"
                            onClick={()=>{}}
                          >
                            Gestão
                          </button>
                        </div>
                      </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>



              </div>

            </div>

            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 gap-2 text-xs">
                <button
                  onClick={() => handlePageChange(currentPageRequests - 1)}
                  disabled={currentPageRequests === 1}
                  className={`px-2 py-1 rounded-md ${currentPageRequests === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                >
                  {'<'}
                </button>

                {/* Botão para a primeira página */}
                {currentPageRequests > 2 && (
                  <>
                    <button
                      onClick={() => handlePageChange(1)}
                      className="px-2 py-1 rounded-md bg-gray-300"
                    >
                      1
                    </button>
                    {currentPageRequests >= 3 && <span className="px-2 py-1">...</span>}
                  </>
                )}

                {/* Botões ao redor da página atual */}
                {Array.from({ length: 3 }, (_, i) => {
                  const page = currentPageRequests - 1 + i;
                  if (page > 0 && page <= requestList.totalPages) {
                    return (
                      <button
                        key={page}
                        onClick={() => handlePageChange(page)}
                        className={`px-2 py-1 rounded-md ${page === currentPageRequests ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                      >
                        {page}
                      </button>
                    );
                  }
                  return null;
                })}

                {/* Botão para a última página */}
                {currentPageRequests < requestList.totalPages - 1 && (
                  <>
                    {currentPageRequests < requestList.totalPages - 2 && <span className="px-2 py-1">...</span>}
                    <button
                      onClick={() => handlePageChange(requestList.totalPages)}
                      className="px-2 py-1 rounded-md bg-gray-300"
                    >
                      {requestList.totalPages}
                    </button>
                  </>
                )}

                <button
                  onClick={() => handlePageChange(currentPageRequests + 1)}
                  disabled={currentPageRequests === requestList.totalPages}
                  className={`px-2 py-1 rounded-md ${currentPageRequests === requestList.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
                >
                  {'>'}
                </button>
              </div>
            
          </div>

        </div>

      </div>

      {requestOnDetailsModal && 
        <div className="absolute">
          <RequestDetailsModal
            isModalOpen={requestDetailsModal}
            setModalOpen={() => {
              setRequestDetailsModal(!requestDetailsModal);
            }}
            requestId={requestOnDetailsModal}
            // setTicketCb={setTicket}
          ></RequestDetailsModal>
        </div>
      }

    </div>
  )
}
